import React from "react";
import {observer} from "mobx-react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {LinearProgress} from "@mui/material";
import {useStores} from "../../Hooks";

const ProgressLoaderModal = observer(() => {
    const {generalStore} = useStores();
    const top = window.scrollY;
    return (
        <ConditionalComponent if={generalStore.progressLoaderValue !== null && generalStore.isProgressLoaderLinear && !generalStore.isBlockGeneralLinearModal}>
            <div className='linear-progress-container' style={{top}}>
                <div className='title-and-bar-container'>
                    <div className='in-progress-title'>
                        {generalStore.progressLoaderString}
                    </div>
                    <LinearProgress
                        color="primary"
                        value={generalStore.progressLoaderValue}
                        variant="determinate"
                    />
                </div>
            </div>
        </ConditionalComponent>
    );
});

export default ProgressLoaderModal;
